import { Box } from '@mui/material';
import React, { useCallback, useMemo, useState } from 'react';

import { TEMPLATE_ERROR_TOOLTIP_TEXT } from '../../../constants/oneLink';
import { TEMPLATE_CARD_CONFIG } from '../../../constants/templates';
import { IOneLinkErrors, OneLinkChunksEnum, TUpdateOneLinkChunk } from '../../../contexts/OneLinkSummaryProvider';
import { useClaimLinkTemplate } from '../../../hooks/useClaimLinkTemplate';
import { IOneLinkWithCampaignSummaries } from '../../../types/oneLink';
import { IClaimLinkTemplate } from '../../../types/templates';
import { ClaimLinkTemplateCard, ClaimLinkTemplateCardBase } from '../../TemplatesComponent';
import { ChooseClaimLinkTemplateModal } from '../../_mui';
import { Section } from './common';

interface IProps {
  instance: IOneLinkWithCampaignSummaries | null | undefined;
  errors?: IOneLinkErrors;
  onSubmit: (chunk: TUpdateOneLinkChunk) => void;
}

export const TemplateSection: React.FC<IProps> = ({ instance, errors, onSubmit }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { experience_id } = instance ?? {};
  const template = useClaimLinkTemplate(experience_id);

  const experienceError = useMemo(() => errors?.[OneLinkChunksEnum.ExperienceInfo]?.experience_id, [errors]);

  const handleEdit = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleSelect = useCallback(
    (selectedTemplate: IClaimLinkTemplate) => {
      onSubmit({ experience_info: { experience_id: selectedTemplate.uid } });
      setIsModalOpen(false);
    },
    [onSubmit],
  );

  return (
    <Box
      sx={{
        height: '100%',
        '& > .MuiPaper-root': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          '& > :last-child': { flex: 1 },
        },
      }}
    >
      <Section
        title="Claim page template"
        minHeight={420}
        onEdit={handleEdit}
        errors={experienceError}
        tooltipText={TEMPLATE_ERROR_TOOLTIP_TEXT}
        editDataAction="edit_claim_page_template_btn"
      >
        <Box
          sx={{ width: '100%', maxWidth: 430, height: '100%', '& .MuiCard-root': { maxWidth: '100%', height: '100%' } }}
        >
          {template ? (
            <ClaimLinkTemplateCard template={template} config={TEMPLATE_CARD_CONFIG} />
          ) : (
            <ClaimLinkTemplateCardBase title="No template selected" isHighlighted={false} />
          )}
        </Box>
      </Section>
      <ChooseClaimLinkTemplateModal
        isOpen={isModalOpen}
        onClose={handleClose}
        onSelect={handleSelect}
        currentTemplateId={experience_id}
        departmentId={instance?.department_id}
      />
    </Box>
  );
};
